
export const STAFF_MEMBER_LIST = "STAFF_MEMBER_LIST"
export const STAFF_MEMBER_LIST_SERVICE = "STAFF_MEMBER_LIST_SERVICE"
export const STAFF_MEMBER_ADD = "STAFF_MEMBER_ADD"
export const STAFF_MEMBER_UPDATE = "STAFF_MEMBER_UPDATE"
export const STAFF_MEMBER_Delete = "STAFF_MEMBER_Delete"
export const STAFF_MEMBER_Detail = "STAFF_MEMBER_Detail"
export const STAFF_MEMBER_Status = "STAFF_MEMBER_Status"
export const STAFF_MEMBER_CATEGORY_GET = "STAFF_MEMBER_CATEGORY_GET"
export const STAFF_MEMBER_VIEW_DEATILS = "STAFF_MEMBER_VIEW_DEATILS"

